module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "background": "#f8f8f8",
      "padding-bottom": "5rem"
    }
  }, [_c('div', {
    staticClass: "check-header"
  }, [_c('div', {
    staticClass: "business-shop-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "shop-address"
  }, [_vm._v("请确认考级信息，选择考级人员提交报名")]), _vm._v(" "), _c('div', {
    staticClass: "delivery-times"
  }, [_c('div', {
    staticClass: "timers-start"
  }, [_c('van-icon', {
    attrs: {
      "name": "clock-o"
    }
  }), _vm._v("\n            时间地点\n          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "timers-end"
  }, [_vm._v(_vm._s(_vm.row.province) + _vm._s(_vm.row.city) + "(" + _vm._s(_vm.row.datetitle) + ")")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('van-divider', [_vm._v("考级信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "星级",
      "value": _vm.starType
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "地址",
      "value": _vm.row.address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系电话",
      "value": _vm.row.phone
    }
  })], 1), _vm._v(" "), (!_vm.isSubmit) ? _c('van-divider', [_vm._v("运动员信息")]) : _vm._e(), _vm._v(" "), (!_vm.isSubmit) ? _c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "label": "姓名",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请填入报名人员姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "证件类型"
    },
    on: {
      "click": function($event) {
        _vm.showNumTypePicker = true
      }
    },
    model: {
      value: (_vm.formData.numTypeName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "numTypeName", $$v)
      },
      expression: "formData.numTypeName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("满14周岁以上不可参与考级")]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNumTypePicker),
      callback: function($$v) {
        _vm.showNumTypePicker = $$v
      },
      expression: "showNumTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.numTypeColumns,
      "show-toolbar": "",
      "default-index": _vm.formData.numtype - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showNumTypePicker = false
      },
      "confirm": _vm.onNumTypeConfirm
    }
  })], 1), _vm._v(" "), (_vm.formData.numtype == 1) ? _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }) : _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '护照号不能为空'
      }],
      "error-message-align": "right",
      "label": "护照号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入护照号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("下一步\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSubmit) ? _c('van-divider', [_vm._v("运动员信息确认")]) : _vm._e(), _vm._v(" "), (_vm.isSubmit) ? _c('van-form', {
    on: {
      "submit": _vm.onConfirm
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "label": "姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("此处填写运动员姓名后将不予修改，须返回上一步重新认证运动员")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "证件号",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }), _vm._v(" "), (_vm.formData.numtype != 1) ? _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "label": "生日",
      "input-align": "right",
      "error-message-align": "right",
      "placeholder": "请选择生日",
      "rules": [{
        required: true,
        message: '请选择生日'
      }]
    },
    on: {
      "click": function($event) {
        _vm.showDate = true
      }
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", $$v)
      },
      expression: "formData.birthday"
    }
  }) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDate),
      callback: function($$v) {
        _vm.showDate = $$v
      },
      expression: "showDate"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "type": "date",
      "title": "选择年月日",
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate
    },
    on: {
      "confirm": _vm.onDateConfirm,
      "cancel": function($event) {
        _vm.showDate = false
      }
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  })], 1), _vm._v(" "), (_vm.formData.numtype != 1) ? _c('van-cell', {
    attrs: {
      "title": "护照照片"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.numtype != 1) ? _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.huzhao_pic,
      "limit": 1,
      "name": 'pic'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.numtype != 1) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传护照（姓名和生日页）照片")]) : _vm._e(), _vm._v(" "), _c('van-cell', {
    attrs: {
      "center": "",
      "title": "是否连考"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "active-color": "#ffad19",
            "active-value": 1,
            "inactive-value": 2,
            "size": "24"
          },
          on: {
            "change": _vm.onLiankaoChange
          },
          model: {
            value: (_vm.formData.is_exam_continue),
            callback: function($$v) {
              _vm.$set(_vm.formData, "is_exam_continue", $$v)
            },
            expression: "formData.is_exam_continue"
          }
        })]
      },
      proxy: true
    }], null, false, 2507409752)
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "性别",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.sex),
            callback: function($$v) {
              _vm.$set(_vm.formData, "sex", $$v)
            },
            expression: "formData.sex"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 1
          }
        }, [_vm._v("男")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": 2
          }
        }, [_vm._v("女")])], 1)]
      },
      proxy: true
    }], null, false, 2706601976)
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "error-message-align": "right",
      "label": "报考星级",
      "input-align": "right"
    },
    on: {
      "click": function($event) {
        _vm.showGradePicker = true
      }
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("紫星级须有全国赛事经历；")]), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("连考须达到连考条件")]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showGradePicker),
      callback: function($$v) {
        _vm.showGradePicker = $$v
      },
      expression: "showGradePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.gradeSelectColumns,
      "show-toolbar": "",
      "default-index": _vm.formData.gradeindex - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showGradePicker = false
      },
      "confirm": _vm.onGradeConfirm
    }
  })], 1), _vm._v(" "), (_vm.formData.grade == '绿' || _vm.formData.grade == '青' || _vm.formData.grade == '蓝' || _vm.formData.grade == '紫') ? _c('van-field', {
    attrs: {
      "name": "project",
      "label": "项目类型",
      "rules": [{
        required: true,
        message: '请选择项目类型'
      }],
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.project),
            callback: function($$v) {
              _vm.$set(_vm.formData, "project", $$v)
            },
            expression: "formData.project"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "花球"
          }
        }, [_vm._v("花球")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "街舞"
          }
        }, [_vm._v("街舞")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "爵士"
          }
        }, [_vm._v("爵士")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "技巧"
          }
        }, [_vm._v("技巧")])], 1)]
      },
      proxy: true
    }], null, false, 3411667332)
  }) : _vm._e(), _vm._v(" "), (_vm.row.center.kaoji_jiameng_type == 7) ? _c('van-field', {
    attrs: {
      "name": "project",
      "label": "项目类型",
      "rules": [{
        required: true,
        message: '请选择项目类型'
      }],
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.project),
            callback: function($$v) {
              _vm.$set(_vm.formData, "project", $$v)
            },
            expression: "formData.project"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "街舞"
          }
        }, [_vm._v("街舞")])], 1)]
      },
      proxy: true
    }], null, false, 567865502)
  }) : _vm._e(), _vm._v(" "), (_vm.formData.grade == '绿' || _vm.formData.grade == '青' || _vm.formData.grade == '蓝' || _vm.formData.grade == '紫') ? _c('van-field', {
    attrs: {
      "name": "project",
      "label": "项目类型",
      "rules": [{
        required: true,
        message: '请选择项目类型'
      }],
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.project),
            callback: function($$v) {
              _vm.$set(_vm.formData, "project", $$v)
            },
            expression: "formData.project"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "花球"
          }
        }, [_vm._v("花球")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "街舞"
          }
        }, [_vm._v("街舞")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "爵士"
          }
        }, [_vm._v("爵士")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "技巧"
          }
        }, [_vm._v("技巧")])], 1)]
      },
      proxy: true
    }], null, false, 3411667332)
  }) : _vm._e(), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "添加证件照片(2寸)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 1,
      "name": 'pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传2寸免冠照,此照片用于证书粘贴打印")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "品德文件（可选）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('FileUploader', {
    attrs: {
      "uploadText": "上传文件",
      "fileList": _vm.formData.pindei_file,
      "limit": 1,
      "accept": ".zip,.rar,.xls,.xlsx",
      "name": 'pindei_file'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("图片+内容")]), _vm._v(" "), (_vm.formData.grade.indexOf('红') != -1) ? _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "clearable": "",
      "left-icon": "question-o",
      "rules": [{
        required: true,
        message: '请输入尺码'
      }],
      "label": "衣服尺码",
      "placeholder": "请输入尺码",
      "input-align": "right"
    },
    on: {
      "click-left-icon": function($event) {
        _vm.cSizeShow = true
      }
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }) : _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "clearable": "",
      "left-icon": "question-o",
      "label": "衣服尺码",
      "placeholder": "请输入尺码",
      "input-align": "right"
    },
    on: {
      "click-left-icon": function($event) {
        _vm.cSizeShow = true
      }
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left",
    on: {
      "click": function($event) {
        _vm.cSizeShow = true
      }
    }
  }, [_vm._v("查看衣服尺码表")]), _vm._v(" "), (_vm.formData.grade.indexOf('红') != -1) ? _c('van-field', {
    attrs: {
      "clearable": "",
      "rules": [{
        required: true,
        message: '请输入鞋码'
      }],
      "error-message-align": "right",
      "label": "鞋  码",
      "placeholder": "请输入鞋码",
      "input-align": "right"
    },
    on: {
      "click-left-icon": function($event) {
        _vm.fSizeShow = true
      }
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  }) : _c('van-field', {
    attrs: {
      "clearable": "",
      "error-message-align": "right",
      "label": "鞋  码",
      "placeholder": "请输入鞋码",
      "input-align": "right"
    },
    on: {
      "click-left-icon": function($event) {
        _vm.fSizeShow = true
      }
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left",
    on: {
      "click": function($event) {
        _vm.fSizeShow = true
      }
    }
  }, [_vm._v("查看鞋码表")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("下一步\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "信息核对",
      "show-cancel-button": ""
    },
    on: {
      "confirm": function($event) {
        return _vm.onConfirmSubmit()
      }
    },
    model: {
      value: (_vm.confirmShow),
      callback: function($$v) {
        _vm.confirmShow = $$v
      },
      expression: "confirmShow"
    }
  }, [_c('van-cell-group', {
    staticStyle: {
      "height": "8rem",
      "overflow-y": "scroll"
    }
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "label": "姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "证件号",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "报考星级",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }), _vm._v(" "), (_vm.formData.pic.length > 0) ? _c('van-cell', {
    attrs: {
      "title": "证件照片(2寸)"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.formData.pic[0].url,
      "width": "100"
    }
  })]) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "衣服尺码",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "鞋  码",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  })], 1)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "衣服尺码表"
    },
    model: {
      value: (_vm.cSizeShow),
      callback: function($$v) {
        _vm.cSizeShow = $$v
      },
      expression: "cSizeShow"
    }
  }, _vm._l((_vm.cSizePicList), function(pic, key) {
    return _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": pic
      },
      on: {
        "click": function($event) {
          return _vm.picShow(key, _vm.cSizePicList)
        }
      }
    })
  }), 0), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "鞋码表"
    },
    model: {
      value: (_vm.fSizeShow),
      callback: function($$v) {
        _vm.fSizeShow = $$v
      },
      expression: "fSizeShow"
    }
  }, [_c('p', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_vm._v("此鞋型偏小，建议选大一码")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.fSizePicList[0]
    },
    on: {
      "click": function($event) {
        return _vm.picShow(0, _vm.fSizePicList)
      }
    }
  })]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "business-shop-box"
  }, [_c('div', {
    staticClass: "shop-name"
  }, [_c('div', {
    staticStyle: {
      "font-size": "19px"
    }
  }, [_vm._v("七彩星级考级报名")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e3a9bd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyMemberAdd.vue
// module id = 2545
// module chunks = 0